export const engagementAppGroupIdFeatureFlagsTags = "/engagement/:app_group_id/feature_flags/tags";
